// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AutoCompleteResults-cls1___57dde747b4a193f68fe{/*!*/}.AutoCompleteResults-cls2___2f96b4a507ce6735a09{display:flex;justify-content:center;align-items:center;padding:30px;color:#333;font-size:14px;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AutoCompleteResults-cls1___57dde747b4a193f68fe",
	"cls2": "AutoCompleteResults-cls2___2f96b4a507ce6735a09 AutoCompleteResults-cls1___57dde747b4a193f68fe"
};
export default ___CSS_LOADER_EXPORT___;
